import mapKeys from 'lodash/mapKeys';
import environment from '../environment';
import { getExpertId } from '../util/parseSelectors';
import { _getState } from '../store';
import {
  extractSelectedTicketFromState,
  getAnalyticsSessionOfSelectedTicket,
  getAbTestingConfig,
  isSpecialist,
  getRecommendedMLTagsForSelectedTicket,
  getToDisplayRecommendedMLTagsForSelectedTicket,
  getRequestDetailsRecommendedMLTagsForSelectedTicket,
  extractCommerceWizardRecommendationData,
  extractCommerceWizardSelectedRecommendation,
  extractSelectedNonHistoricalTicketFromState,
} from '../extractFromState';
import { captureException } from '../util/error';
import request from '../util/superagent';
import get from 'lodash/get';

// new more simple analytics function that handles the parse pointers later
export const postAnalyticsEventSimple = (eventName, params) => {
  return postAnalyticsEvent(eventName, {}, params);
};

// Note: Do not have an exact key in params as 'id', the Parse will throw an error
export const postAnalyticsEvent = async (eventName, parsePointers, params = {}, customParsePointers = []) => {
  try {
    // add the pointers and params for every event
    parsePointers = Object.assign({}, getParsePointersForSelectedTicket(), parsePointers);
    params = Object.assign({}, getDefaultParamsForEvent(), params);

    await request
      .post(`${environment.services.analyticsUrl}/trackEvent`)
      .set('Accept', 'application/json')
      .send({ eventName, parsePointers, params, customParsePointers });
  } catch (err) {
    captureException(err);
  }
};

export const buildSessionAnalyticsParams = (parsePointers = {}, params = {}) => ({
  ...params,
  ...turnPointersIntoIds(parsePointers),
});

const turnPointersIntoIds = (pointers) =>
  mapKeys(pointers, (_ignored, key) => (key.slice(-3) === 'Ptr' ? key.slice(0, -3) + 'Id' : key));

const getDefaultParamsForEvent = () => {
  let out = {};

  const ticketSelectionSession = getAnalyticsSessionOfSelectedTicket(_getState());
  if (ticketSelectionSession) {
    out.ticketSelectionSession = ticketSelectionSession;
  }
  const abTestingConfig = getAbTestingConfig(_getState());
  if (abTestingConfig) {
    out = Object.assign({}, out, abTestingConfig);
  }
  out.isAdmin = isSpecialist(_getState());

  return out;
};

export const getParsePointersForSelectedTicket = () => {
  const ticket = extractSelectedTicketFromState(_getState());
  const { ticketId, simplrAccountPtrId } = ticket || {};

  return {
    conversationPtr: ticketId,
    simplrAccountPtr: simplrAccountPtrId,
    simplrExpertPtr: getExpertId(),
  };
};

export const getRecommendedMLTagsEventData = () => {
  const state = _getState();
  const tags = getRecommendedMLTagsForSelectedTicket(state);
  const toDisplay = getToDisplayRecommendedMLTagsForSelectedTicket(state);
  const requestDetails = getRequestDetailsRecommendedMLTagsForSelectedTicket(state);

  return {
    tags,
    toDisplay,
    requestDetails,
  };
};

export const getCommerceEventData = () => {
  const state = _getState();
  const requestDetails = extractCommerceWizardRecommendationData(state);
  const selectedRecommendation = extractCommerceWizardSelectedRecommendation(state);

  return {
    requestDetails: {
      detectionSource: get(requestDetails, 'detectionSource'),
      noShowReason: get(requestDetails, 'noShowReason'),
    },
    detectedProductId: get(requestDetails, 'productDetected.id'),
    selectedProductRecommendationId: get(selectedRecommendation, 'id'),
  };
};

export const getParsePointersForSelectedNonHistoricalTicket = () => {
  const ticket = extractSelectedNonHistoricalTicketFromState(_getState());
  const { ticketId, simplrAccountPtrId } = ticket || {};

  return {
    conversationPtr: ticketId,
    simplrAccountPtr: simplrAccountPtrId,
    simplrExpertPtr: getExpertId(),
  };
};
